import * as React from "react";

function SvgHelp(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <g data-name="Grupo 433">
        <g data-name="Caminho 13" fill="none">
          <path d="M10 0A10 10 0 110 10 10 10 0 0110 0z" />
          <path
            d="M10 1.8c-4.521 0-8.2 3.679-8.2 8.2 0 4.521 3.679 8.2 8.2 8.2 4.521 0 8.2-3.679 8.2-8.2 0-4.521-3.679-8.2-8.2-8.2M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z"
            fill="currentColor"
          />
        </g>
        <path
          d="M10.792 12.436h-1.7q-.007-.371-.007-.452a3.05 3.05 0 01.273-1.377 4.18 4.18 0 011.095-1.216 8.213 8.213 0 00.978-.885 1.194 1.194 0 00.246-.729 1.236 1.236 0 00-.436-.949 1.683 1.683 0 00-1.174-.4 1.763 1.763 0 00-1.191.415 2.2 2.2 0 00-.659 1.256L6.5 7.885a2.906 2.906 0 011.015-2.053 3.563 3.563 0 012.472-.844 3.692 3.692 0 012.562.855 2.6 2.6 0 01.952 1.989 2.21 2.21 0 01-.35 1.187 7.73 7.73 0 01-1.494 1.524 2.879 2.879 0 00-.735.8 2.731 2.731 0 00-.13 1.093zm-1.7 2.552v-1.897h1.87v1.9z"
          data-name="Caminho 12"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgHelp;

